module.exports = __webpack_public_path__ + "d3883469b77e706af1f436b97647d911.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2018-04-24/whats-new.html
// module id = 1910
// module chunks = 0